import { combineReducers } from '@ngrx/store';
import * as fromBusinessLine from './business-line/business-lines.reducer';
import * as fromShippingCondition from './shipping-condition/shipping-conditions.reducer';

export interface IBusinessLineState {
  businessLine: fromBusinessLine.BusinessLinesState;
  shippingCondition: fromShippingCondition.ShippingConditionsState;
}

export const reducers = combineReducers({
  businessLine: fromBusinessLine.businessLineReducer,
  shippingCondition: fromShippingCondition.shippingConditionsReducer,
});
